import { render, staticRenderFns } from "./RegistroRealizado.vue?vue&type=template&id=7ac66f06&scoped=true"
import script from "./RegistroRealizado.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroRealizado.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RegistroRealizado.vue?vue&type=style&index=0&id=7ac66f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac66f06",
  null
  
)

export default component.exports